export enum NewsfeedTargetAudience {
	AllUsers = 'all_users',
	UsersWithBots = 'users_with_bots',
	UsersWithZeroBots = 'users_with_zero_bots',
}
